import React, { createContext } from "react"
import { navigate } from "gatsby"
import { getLocaleFromPath, getLocalizedPath } from "../utils/routes"

export const LanguageContext = createContext({
  locale: "en",
  pathname: "/",
  changeLanguage: () => {},
  toggleLanguage: () => {},
})

const LanguageProvider = ({ children, pathname = "/" }) => {
  // The URL determines the language during SSR and in the browser.
  // Browser preferences must not override an explicit /pl/ or /en/ URL.
  const locale = getLocaleFromPath(pathname)
  const changeLanguage = newLocale => {
    if (typeof window === "undefined") return
    try {
      window.localStorage.setItem("preferredLocale", newLocale)
    } catch {
      // Navigation also works when browser storage is unavailable.
    }
    navigate(
      getLocalizedPath(
        window.location.pathname +
          window.location.search +
          window.location.hash,
        newLocale
      )
    )
  }

  return (
    <LanguageContext.Provider
      value={{
        locale,
        pathname,
        changeLanguage,
        toggleLanguage: () => changeLanguage(locale === "pl" ? "en" : "pl"),
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export default LanguageProvider
